import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import DuplicatePersonTable from "../../Presentational/DuplicatePerson/DuplicatePersonTable";
const searchArgs = {
    ezMerge: false,
    ignored: false,
    personA_IsMergeable: true,
    personB_IsMergeable: true,
    merged: false,
};
const DuplicatePersonReviewTab = ({ id, counterState, }) => {
    const actions = [
        {
            id: 1,
            name: "Ignore",
            icon: "ban",
            title: "Ignore",
        },
    ];
    return (_jsx(DuplicatePersonTable, { actions: actions, search: Object.assign(Object.assign({}, searchArgs), { ruleSetIds: [id] }), counterState: counterState }));
};
export default DuplicatePersonReviewTab;
